import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { ShareButtons } from 'ngx-sharebuttons/buttons';
import { emulateClick } from '../core/a11y';
import { DrawerService } from '../drawer/drawer.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-share-socials',
  imports: [
    NgxTolgeeModule,
    ShareButtons
  ],
  templateUrl: './share-socials.component.html'
})
export class ShareSocialsComponent {
  readonly emulateClick = emulateClick;
  drawerService = inject(DrawerService);
  description = inject(Meta).getTag('description')?.content ?? ''
  title = inject(Title).getTitle();
}
